// @ts-check

import { checkArrayOnlyType } from 'libs/types/checkTypes';

/**
 * @function sortAddresses
 * @param {ProfileEditorAddressType[]} addresses
 * @return {ProfileEditorAddressType[]}
 */
function sortAddresses(addresses) {
	checkArrayOnlyType(addresses);

	const sortedAddresses = addresses.sort((a, b) => {
		if (a.type === '' || a.type === undefined) {
			return 1;
		}

		if (b.type === '' || b.type === undefined) {
			return -1;
		}

		return parseInt(a.type) - parseInt(b.type);
	});

	return sortedAddresses;
}

export default sortAddresses;
